//src/app/features/questionnaires/create/TaxRequestTarget/fields.tsx
import { store } from 'app/redux/store';
import { AddIcon } from 'assets/icons';
import Button from 'Components/Buttons/Button';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import {
  TaxRequestTargetState,
  TaxRequestType,
  TaxReturnOwnership,
  updateKey,
} from '../PrepareQuestionnaire/slice';
import { useGetUserBusinessesQuery } from 'app/services/user';

export function useGetFields(): IBaseField<keyof TaxRequestTargetState>[] {
  const { data: businesses } = useGetUserBusinessesQuery();
  const navigate = useNavigate();

  return [
    {
      type: 'radio',
      name: 'taxRequestType',
      label: 'Is this Tax Request for an individual or for a business?',
      options: [
        { label: 'Individual', value: TaxRequestType.Individual },
        { label: 'Business', value: TaxRequestType.Business },
      ],
      effect: (payload) => store.dispatch(updateKey(payload)),
      dependencies: [
        {
          type: 'select',
          name: 'businessId',
          dependenciesTitle: (
            <div className="w-full flex justify-end">
              <Button
                className="max-w-min"
                onClick={() => navigate('/dashboard/profile/businesses/create')}
              >
                <AddIcon />
                New Business
              </Button>
            </div>
          ),
          label: 'Choose the business needed',
          effect: (payload) => store.dispatch(updateKey(payload)),
          options: (businesses || []).map((b) => ({
            label: b.name,
            value: b.id.toString(),
            subscribed: b.subscribed,
          })),
          predicate: (value: TaxRequestTargetState['taxRequestType']) =>
            value === TaxRequestType.Business,
        },
        {
          type: 'specialization',
          name: 'specializationId',
          label: 'Your Industry',
          effect: (payload) => store.dispatch(updateKey(payload)),
          predicate: (value: TaxRequestTargetState['taxRequestType']) =>
            value === TaxRequestType.Individual,
        },

        {
          type: 'radio',
          name: 'taxReturnOwnership',
          label: 'Tax Request Type',
          effect: (payload) => store.dispatch(updateKey(payload)),
          options: [
            {
              label: 'Primary Tax Payer',
              value: TaxReturnOwnership.PrimaryTaxPayer,
            },
            {
              label: 'Spouse or Dependent',
              value: TaxReturnOwnership.SpouseOrDependent,
            },
          ],
          predicate: (value: TaxRequestTargetState['taxRequestType']) =>
            value === TaxRequestType.Individual,
          dependencies: [
            {
              type: 'select',
              name: 'spouseOrDependentId',
              label: 'Spouse or Dependent',
              options: [],
              effect: (payload) => store.dispatch(updateKey(payload)),
              predicate: (value: TaxRequestTargetState['taxReturnOwnership']) =>
                value === TaxReturnOwnership.SpouseOrDependent,
            },
          ],
        },
      ],
    },
  ];
}

export const validationSchema = Yup.object().shape({
  taxRequestType: Yup.string().nullable().required('required'),
  businessId: Yup.string().when('taxRequestType', {
    is: (value: string) => value === TaxRequestType.Business,
    then: Yup.string().nullable().required('required'),
    otherwise: Yup.string().nullable(),
  }),
  specializationId: Yup.string().when('taxRequestType', {
    is: (value: string) => value === TaxRequestType.Individual,
    then: Yup.string().nullable().required('required'),
    otherwise: Yup.string().nullable(),
  }),
  taxReturnOwnership: Yup.string().when('taxRequestType', {
    is: (value: string) => value === TaxRequestType.Individual,
    then: Yup.string().nullable().required('required'),
    otherwise: Yup.string().nullable(),
  }),
  spouseOrDependentId: Yup.string().when('taxReturnOwnership', {
    is: (value: string) => value === TaxReturnOwnership.SpouseOrDependent,
    then: Yup.string().nullable().required('required'),
    otherwise: Yup.string().nullable(),
  }),
});
